import Swiper from 'swiper/bundle'
import gsap from 'gsap';
import { SplitText } from 'gsap/SplitText'

export default class ImgLink {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.splitLinesTitle = new SplitText(this.el.querySelectorAll('.img-link--title-metier'), { type: 'lines', mask: 'lines' })
    this.splitLinesText = new SplitText(this.el.querySelectorAll('.img-link--text'), { type: 'words', mask: 'lines' })

    this.init()
  }

  init() {
    this.initSwiper()
    this.initDesktop()
    this.metiersContentAnimation()
  }

  initSwiper() {
    const swiperEl = this.el.querySelector('.img-link--slider')
    if (!swiperEl) return
    this.swiper = new Swiper(swiperEl, {
      slidesPerView: 1.1,
      spaceBetween: 16,
      grabCursor: true,
    })
  }

  initDesktop() {
    this.el.querySelector('#img-0')?.classList.add('is-active')
    this.el.querySelector('#text-0')?.classList.add('is-active')
    this.el.querySelector('#title-0')?.classList.add('is-active')

    this.el.querySelectorAll('.img-link--title-metier').forEach(title => {
      title.addEventListener('mouseenter', () => {
        this.el.querySelectorAll('.img-link--title-metier').forEach(t => t.classList.remove('is-active'))
        this.el.querySelectorAll('.img-link--wrapper-content, .img-link--img').forEach(el => el.classList.remove('is-active'))

        const index = title.id.replace('title-', '')
        this.el.querySelector(`#text-${index}`)?.classList.add('is-active')
        this.el.querySelector(`#img-${index}`)?.classList.add('is-active')
        title.classList.add('is-active')
      })
    })
  }

  metiersContentAnimation() {
    this.splitLinesTitle.lines.forEach(line => {
      gsap.set(line, { y: 24, opacity: 0 });

      gsap.to(line, {
        stagger: 0.07,
        scrollTrigger: {
          trigger: line,
          start: "top 80%",
          toggleActions: "play none none none",
        },
        ease: "power3.out",
        opacity: 1,
        y: 0,
        duration: 1,
      })
    })

    this.splitLinesText.words.forEach(word => {
      gsap.set(word, { y: 24, opacity: 0 });

      gsap.to(word, {
        stagger: 0.07,
        scrollTrigger: {
          trigger: word,
          start: "top 80%",
          toggleActions: "play none none none",
        },
        ease: "power3.out",
        opacity: 1,
        y: 0,
        duration: 1,
      })
    })
  }
}
